import QuerySummary from './QuerySummary';

export default QuerySummary;
